import React from "react";
import { UI_TAG, Divider } from "oolib";
import { StyledScrollWrapper, SECTION_LABEL_STYLE, StyledSectionDivider } from "../styled";

/**
 * ─────────────────────────────────────────────────────────────────────────
 *  Dev-2 presentational seam. Panel chrome = scroll container, section labels,
 *  dividers. Purely visual; no logic. Dev-1 wired the structure, Dev-2 owns
 *  how it looks.
 * ─────────────────────────────────────────────────────────────────────────
 */

/** Scrollable wrapper for a panel body. `data-lightbox-header` on labels keeps
 *  them sticky-compatible with the lightbox shell (matches DocHierarchyFilter). */
export const ScrollWrapper = ({ children, style }) => (
  <StyledScrollWrapper style={style}>{children}</StyledScrollWrapper>
);

export const SectionLabel = ({ children }) =>
  children ? (
    <div data-lightbox-header>
      <UI_TAG style={SECTION_LABEL_STYLE}>{children}</UI_TAG>
    </div>
  ) : null;

export const SectionDivider = () => (
  <StyledSectionDivider>
    <Divider />
  </StyledSectionDivider>
);
